module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('abstract-button', {
    staticClass: "mu-float-button",
    class: [_vm.buttonClass],
    style: (_vm.buttonStyle),
    attrs: {
      "type": _vm.type,
      "href": _vm.href,
      "target": _vm.target,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick,
      "keyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [_c('div', {
    staticClass: "mu-float-button-wrapper"
  }, [_vm._t("default", function() {
    return [_c('icon', {
      class: _vm.iconClass,
      attrs: {
        "value": this.icon
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1238da5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/floatButton/floatButton.vue
// module id = 3055
// module chunks = 1